/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2022.

!Changelog

2022
	- [ADDED] matomo.track(pageview) and googleanalytics.track(pageview) on init;
2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function() {
	 
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Tracking: Pageview (only when it's not the firstload);
		*/
		if(isFirstLoad !== 1) {

			if(
				typeof _analytics_google_id !== 'undefined'
			) {
				googleanalytics.track(
					'pageview'
				);
			}

			if(
				typeof _analytics_matomo_id !== 'undefined'
			) {
				matomo.track(
					'pageview'
				);
			}

		}

		/*
		Trigger: Instagram
		*/
		//specific_instagram.onready('thumb',8,true);

		/*
		Trigger: Facebook
		*/
		//specific_facebook.onready(6,true);

		/*
		Catch and active URL
		*/
		// var _url_active_main = './';
		
		// $('.js-nav-item').removeClass('active');
		
		// if(url[2] !== '') { 
		// 	_url_active_main = url[1] + '/' + url[2]; 
		// } else {
		// 	if(url[1] !== '') { 
		// 		_url_active_main = url[1];
		// 	}
		// }

		// if(_url_active_main !== '') {
		// 	$('.js-nav-item[data-go-url="' + _url_active_main + '"]').addClass('active');
		// }

		/*
		Scrollto
		*/
		_marge = 50;
		
		if(url[1] == 'informatie') {
			$('body,html').animate({
			    scrollTop: $('.js-page-informatie').offset().top - _marge
			},600);
		}
		if(url[1] == 'voordelen') {
			$('body,html').animate({
			    scrollTop: $('.js-page-voordelen').offset().top - _marge
			},600);
		}
		if(url[1] == 'mogelijkheden') {
			$('body,html').animate({
			    scrollTop: $('.js-page-mogelijkheden').offset().top - _marge
			},600);
		}
		if(url[1] == 'contact') {
			$('body,html').animate({
			    scrollTop: $('.js-page-contact').offset().top - _marge
			},600);
		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
